<template>
  <div id="app" class="rr-events layout">
    <div class="layout__header"></div>
    <div class="header-offset"></div>
    <router-view/>
    <alerts></alerts>
    <rr-notifications></rr-notifications>
  </div>
</template>

<script>
import Alerts from '@/components/Alerts.vue';
import RrNotifications from '@/components/Notifications.vue';
import { mapActions } from 'vuex';

export default {
  metaInfo() {
    return this.$root.setMetaInfo({
      title: this.$i18n.t('meta.eventsTitle'),
    });
  },
  components: {
    Alerts,
    RrNotifications,
  },
  methods: {
    ...mapActions('events', ['getFilters']),
    detectTouch() {
      let isTouch = false;
      if ('ontouchstart' in document.documentElement) {
        isTouch = true;
      }
      this.$root.isTouch = isTouch;
      this.$root.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      this.$root.android = /android/i.test(navigator.userAgent);
      document.body.className += isTouch ? ' touch' : ' no-touch';
    },
  },
  mounted() {
    this.detectTouch();
  },
  created() {
    this.$t = this.$i18n.t;
    this.$root.$modals = {};
    this.$root.$env = process.env;
    this.getFilters();
  },
  beforeCreate() {
    this.$root.setMetaInfo = ({ title }) => {
      const titleTemplate = '%s - SportTiming';
      return {
        title,
        titleTemplate,
        meta: [
          {
            property: 'og:title',
            content: title,
            vmid: 'og:title',
            template: titleTemplate,
          },
          {
            name: 'title',
            content: title,
            vmid: 'title',
            template: titleTemplate,
          },
          {
            name: 'mrc__share_title',
            content: title,
            vmid: 'mrc__share_title',
            template: titleTemplate,
          },
        ],
      };
    };
  },
  watch: {
    $route: {
      handler(val) {
        if (window.onEventRouteChange) {
          window.onEventRouteChange(val.name);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
  @import "https://unpkg.com/leaflet@1.6.0/dist/leaflet.css";
  @import "@/assets/scss/utils/vars.scss";
  @import "@/assets/scss/utils/mixins.scss";

  .body-content > .container {
    padding: 0;
    max-width: 100%;
  }

  .empty-sub-header {
    height: 0;
  }

  .header-offset {
    flex: 0 0 auto;
    height: 56px;

    @media (min-width: breakpoint(md)) {
      height: 64px;
    }
  }

  .mobile-mode .wrapper {
    padding: 0;
  }
</style>
